var map = {
	"./1000000Pkg.png": "RY0o",
	"./100000Pkg.png": "7Vs3",
	"./500000Pkg.png": "K/5M",
	"./50000Pkg.png": "/x2Q",
	"./5P_dot.png": "ej+5",
	"./5P_dotted.png": "o+2r",
	"./Booking.png": "321u",
	"./BookingHover.png": "mfX7",
	"./bookProgress.png": "ThpD",
	"./box4arrow.png": "gNDl",
	"./box4bg.png": "fc03",
	"./gzhCode.jpg": "4wS8",
	"./jianshi.png": "jZZj",
	"./jianshiClick.png": "n6IB",
	"./jianshiIcon.png": "8q6x",
	"./jianshiSkill.png": "vPZI",
	"./jianshiTitle.png": "o+3c",
	"./new_bg.png": "gBd/",
	"./news0.jpg": "HbSN",
	"./news1.jpg": "6uWW",
	"./progressBg.png": "uiJV",
	"./progressUp.png": "ZCQ7",
	"./progress_dot.png": "x88g",
	"./progress_dotted.png": "UZjI",
	"./rightSides.png": "mFgC",
	"./shushi.png": "AY2r",
	"./shushiClick.png": "Hwiz",
	"./shushiIcon.png": "1iqL",
	"./shushiSkill.png": "wKl3",
	"./shushiTitle.png": "1PA6",
	"./yingren.png": "LW3Z",
	"./yingrenClick.png": "gkbU",
	"./yingrenIcon.png": "Zd72",
	"./yingrenSkill.png": "srB8",
	"./yingrenTitle.png": "cyJk",
	"./youxia.png": "9dbZ",
	"./youxiaClick.png": "3DGx",
	"./youxiaIcon.png": "VrPg",
	"./youxiaSkill.png": "2wVg",
	"./youxiaTitle.png": "jeze",
	"./ys_bg.jpg": "XcD0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2/XN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage ^\.\/.*$
// module id = 2/XN
// module chunks = 0